import React, { Component } from "react";
import Alert from "react-s-alert";
import axios from "axios";
import { Modal, Image, Button } from "react-bootstrap";
// import classnames from "classnames";
// import { NavLink } from "react-router-dom";
// import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
// import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
// import Form from "react-bootstrap/Form";
import {
  // InputBoxComponent,
  NewInputText,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { BankAndOtherDetailsHome } from "./BankAndOtherDetailsHome";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import {
  InputCharNumFunc,
  // InputCharacterCheck,
} from "../../../../function/InputCharNumCheckFunc";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
// import BankDetailsUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/BankDetailsUploadComponent";
import SimpleReactLightbox from "simple-react-lightbox";
// import { TermsandConditionPopup } from "../../reusableOnboardingPopupComponent/termsAndConditions/TermsandConditionPopup";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { RestaurantKYCDetailsValidationTwo } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantKYCDetailsValidation";
import {
  create_and_update_restaurant,
  update_vendor_profile,
  logOutUser,
} from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

// import country from "../../../localization/country.json";
import { serverApi } from "../../../../config/Keys";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import BankKycDetailsInformation from "./BankKycDetailsInformation";

export class BankAndOtherDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localizationText: "+91IN",
      openModal: false,
      open: false,
      actionButton: false,
      loader: false,
      selectedTab: 4,
      successPopupOpen: false,
      checkboxAcceptTerms: false,
      selectHomeScreen: 2,
      selectNextScreen: false,
      gstNumber: "",
      fssaiCode: "",
      panCard: "",
      kyc_photo: [],
      bank_Informaion: [],
      hasSetBankProps: false,
      errors: [],
      progress: 0,
    };
  }

  componentDidMount() {
    if (this.props.onboarding._id) {
      this.setState({
        gstNumber: this.props.onboarding.gst_number,
        fssaiCode: this.props.onboarding.fssai_code,
        panCard: this.props.onboarding.pan_card,
        kyc_photo: this.props.onboarding.kyc_photo,
      });
    }

    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.onboarding._id && !isEmpty(nextProps.onboarding.gst_number)) {
      if (
        !isEmpty(nextProps.onboarding.gst_number) &&
        !isEmpty(nextProps.onboarding.selectHomeScreen) &&
        !nextState.hasSetBankProps
      ) {
        return {
          gstNumber: !isEmpty(nextProps.onboarding.gst_number)
            ? nextProps.onboarding.gst_number
            : "",
          fssaiCode: !isEmpty(nextProps.onboarding.fssai_code)
            ? nextProps.onboarding.fssai_code
            : "",
          panCard: !isEmpty(nextProps.onboarding.pan_card)
            ? nextProps.onboarding.pan_card
            : "",
          kyc_photo: !isEmpty(nextProps.onboarding.kyc_photo)
            ? nextProps.onboarding.kyc_photo
            : [],
          hasSetBankProps: true,
        };
      }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logOutUser();
  };

  buttonClickChange = (e) => {
    e.preventDefault();
    this.setState({
      selectHomeScreen: 2,
    });
  };

  backSecondScreenClickChange = (e) => {
    e.preventDefault();
    this.props.history.push("/businessHours");
  };

  handleCloseSuccess = (e) => {
    this.setState({
      openModal: !this.state.openModal,
    });
  };
  setProgress = (e) => {
    this.setState({
      progress: this.state.progress,
    });
  };

  buttonNextClickChangeData = (e) => {
    if (this.props.onboarding.terms_and_condition_accepted === true) {
      this.handleCloseSuccess();
    } else {
      this.props.history.push("/termcondition");
    }
  };

  onCombackLater = (e) => {
    if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        terms_and_condition_accepted: true,
      };
      this.props.create_and_update_restaurant(formData, this.onSuccess);
    }
  };

  onSuccess = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    const formData = {
      have_submited_details_yourself: true,
    };
    this.props.update_vendor_profile(formData, vendor_id, this.callback);
  };

  callback = (e) => {
    this.props.logOutUser();
    window.location.reload();
  };

  buttonNextClickChange = (formData) => {
    const newformData = formData;
    newformData.vendor_id = this.props.onboarding.vendor_id;
    newformData.id = this.props.onboarding._id;
    newformData.selectHomeScreen = this.state.selectHomeScreen;
    newformData.page_completed_till = 21;
    if (this.props.onboarding) {
      this.props.create_and_update_restaurant(formData, this.onSuccessData);
      this.setState({
        actionButton: false,
      });
    }
    // const { errors, isValid } = RestaurantKYCDetailsValidationTwo(this.state);
    // if (!isValid) {
    //   this.setState({
    //     errors: errors,
    //   });
    // } else {
    //   if (
    //     this.props.onboarding &&
    //     this.props.onboarding.fssai_code !== "" &&
    //     this.props.onboarding.fssai_code !== undefined &&
    //     this.props.onboarding.fssai_code !== null
    //   ) {
    //     const formData = {
    //       vendor_id: this.props.onboarding.vendor_id,
    //       id: this.props.onboarding._id,
    //       gst_number: this.state.gstNumber,
    //       fssai_code: this.state.fssaiCode,
    //       pan_card: this.state.panCard,
    //       kyc_photo: this.state.kyc_photo,
    //       selectHomeScreen: this.state.selectHomeScreen,
    //       page_completed_till: 21,
    //     };
    //     this.props.create_and_update_restaurant(formData, this.onSuccessData);
    //     this.setState({
    //       actionButton: false,
    //     });
    //   } else {
    //     const formData = {
    //       vendor_id: this.props.onboarding.vendor_id,
    //       id: this.props.onboarding._id,
    //       gst_number: this.state.gstNumber,
    //       fssai_code: this.state.fssaiCode,
    //       pan_card: this.state.panCard,
    //       kyc_photo: this.state.kyc_photo,
    //       selectHomeScreen: this.state.selectHomeScreen,
    //       page_completed_till: 21,
    //     };
    //     this.props.create_and_update_restaurant(formData, this.onSuccessData);
    //     this.setState({
    //       actionButton: false,
    //     });
    //   }
    // }
  };

  onSuccessData = (e) => {
    this.buttonNextClickChangeData();
  };

  buttonNextBackClickChange = (e) => {
    e.preventDefault();
    this.setState({
      selectNextScreen: false,
    });
  };

  onPoupModelOpen = (e) => {
    this.setState({
      open: true,
    });
  };

  onClosedModel = (e) => {
    this.setState({
      open: false,
    });
  };

  openSuccessModalClick = () => {
    this.setState({
      successPopupOpen: true,
    });
  };

  onClosedModelSuccessModel = () => {
    this.setState({
      open: false,
      successPopupOpen: false,
    });
  };

  handleCheckbox = (e) => {
    this.setState({
      currentSavingAccount: e.currentTarget.value,
      actionButton: true,
    });
  };

  handleCheckboxRemove = (e) => {
    this.setState({
      currentSavingAccount: "",
      actionButton: true,
    });
  };

  onChange = (e) => {
    if (e.target.name === "bankName" || e.target.name === "branchName") {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      this.setState({
        [e.target.name]: newData,
        errors: {},
        actionButton: true,
      });
    } else {
      const { value, maxLength } = e.target;
      const number = value.slice(0, maxLength);
      this.setState({
        [e.target.name]: number,
        errors: {},
        actionButton: true,
      });
    }
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = this.state.kyc_photo;
    oldData.push(e);

    this.setState({
      kyc_photo: oldData,
      actionButton: true,
    });
    this.cancelFiles(file);
  };

  cancelFiles = (file) => {
    let restaurant_pictures_temp = this.state.restaurant_pictures_new;
    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    this.setState({ restaurant_pictures_new: newToUpload });
  };

  kycUploadMultipleFiles = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    var docs = false;
    const config = {
      onUploadProgress: (progressEvent) => {
        let { progress } = this.state;
        progress = (progressEvent.loaded / progressEvent.total) * 100;
        this.setState({ progress });
      },
    };
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures =
        this.state.kyc_photo && this.state.kyc_photo !== ""
          ? this.state.kyc_photo
          : [];
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        if (e.target.files[i].type === "application/pdf") {
          docs = true;
          data.append("files", e.target.files[i]);
        } else {
          newUploaded.push(e.target.files[i]);
        }
      }
    }
    if (!flag) {
      this.setState({
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
      if (docs) {
        axios
          .post(
            `${serverApi}/upload-assets?uploadSide=${combined}`,
            data,
            config
          )
          .then((res) => {
            let oldData = this.state.kyc_photo;
            let newData = res.data;
            let mergedData = oldData.concat(newData);
            this.setState({
              kyc_photo: mergedData,
              actionButton: true,
            });
            this.setState({
              progress: 0,
            });
            Alert.success(`<h4>Bank Details  Upload Successfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          })
          .catch((err) => {
            Alert.error(`<h4>${err}</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  kycDocMultipleRemove = (indexId) => {
    let allKycDetails = this.state.kyc_photo;
    let allKycDetailsObj = allKycDetails.find(
      (images, index) => index === indexId
    );
    if (allKycDetailsObj === 0 || allKycDetailsObj) {
      allKycDetails.splice(allKycDetails.indexOf(allKycDetailsObj), 1);
      this.setState({ allKycDetails: allKycDetails, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  bankUploadMultipleFiles = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures = this.state.bank_Informaion;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        data.append("files", e.target.files[i]);
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.bank_Informaion;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            bank_Informaion: mergedData,
            actionButton: true,
          });
          Alert.success(`<h4>Bank Details Image Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  bankDocMultipleRemove = (indexId) => (e) => {
    let allBankDetails = this.state.bank_Informaion;
    let allBankDetailsObj = allBankDetails.find(
      (images, index) => index === indexId
    );
    if (allBankDetailsObj === 0 || allBankDetailsObj) {
      allBankDetails.splice(allBankDetails.indexOf(allBankDetailsObj), 1);
      this.setState({ allBankDetails: allBankDetails, actionButton: true });
    }
  };

  onWithOutApiCall = (e) => {
    this.buttonNextClickChangeData();
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = RestaurantKYCDetailsValidationTwo(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
        // const formData = {
        //   vendor_id: this.props.auth.user.VendorUser._id,
        //   id: this.props.onboarding._id,
        //   bank_name: this.state.bankName,
        //   current_saving_account: this.state.currentSavingAccount,
        //   account_number: this.state.accountNumber,
        //   branch_name: this.state.branchName,
        //   gst_number: this.state.gstNumber,
        //   fssai_code: this.state.fssaiCode,
        //   pan_card: this.state.panCard,
        //   kyc_photo: this.state.kyc_photo,
        //   bank_informaion: this.state.bank_Informaion,
        //   selectHomeScreen: this.state.selectHomeScreen,
        //   page_completed_till: 21,
        // };
        // this.props.create_and_update_restaurant(formData);
        // this.props.history.push("/termcondition");
        console.log("Bottom");
      }
    }
  };

  renderSecondScreen = () => {
    const { errors, gstNumber, fssaiCode, panCard, kyc_photo, actionButton } =
      this.state;
    return (
      <React.Fragment>
        <div className="bank_and_other_details_onboarding_main">
          <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 p-0">
            <NewInputText
              name="gstNumber"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              onKeyDown={InputCharNumFunc}
              value={this.state.gstNumber}
              maxLength="15"
              errorText={
                gstNumber &&
                gstNumber.length > 0 &&
                gstNumber &&
                gstNumber.length <= 14
                  ? "Enter Valid GST Number"
                  : null || gstNumber === ""
                  ? errors.gstNumber === "gstNumber is required"
                    ? "gstNumber is required"
                    : null
                  : null
              }
              errorTrue={
                (gstNumber &&
                  gstNumber.length > 0 &&
                  gstNumber &&
                  gstNumber.length <= 14) ||
                errors.gstNumber === "gstNumber is required"
                  ? true
                  : false
              }
              labelText="GST Number (15 Char Code)"
              controlClass={
                (gstNumber &&
                  gstNumber.length > 0 &&
                  gstNumber &&
                  gstNumber.length <= 14) ||
                errors.gstNumber === "gstNumber is required"
                  ? "outlined-error-helper-text"
                  : "outlined-helperText"
              }
            />

            <div className="bank-error-message-spacing">
              <NewInputText
                name="fssaiCode"
                inputType="number"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                onKeyDown={InputNumberFunc}
                value={this.state.fssaiCode}
                maxLength="14"
                errorText={
                  fssaiCode &&
                  fssaiCode.length > 0 &&
                  fssaiCode &&
                  fssaiCode.length <= 13
                    ? "Enter valid FSSAI Code"
                    : null || fssaiCode === ""
                    ? errors.fssaiCode === "fssaiCode is required"
                      ? "fssai code is required"
                      : null
                    : null
                }
                errorTrue={
                  (fssaiCode &&
                    fssaiCode.length > 0 &&
                    fssaiCode &&
                    fssaiCode.length <= 13) ||
                  errors.fssaiCode === "fssaiCode is required"
                    ? true
                    : false
                }
                labelText="FSSAI Code (14-character numeric code)"
                controlClass={
                  (fssaiCode &&
                    fssaiCode.length > 0 &&
                    fssaiCode &&
                    fssaiCode.length <= 13) ||
                  errors.fssaiCode === "fssaiCode is required"
                    ? "outlined-error-helper-text"
                    : "outlined-helperText"
                }
              />
            </div>
            <div className="bank-error-message-spacing">
              <NewInputText
                name="panCard"
                inputType="text"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                onKeyDown={InputCharNumFunc}
                value={this.state.panCard}
                maxLength="10"
                errorText={
                  panCard &&
                  panCard.length > 0 &&
                  panCard &&
                  panCard.length <= 9
                    ? "Enter valid Pan Card Number"
                    : null || panCard === ""
                    ? errors.panCard === "panCard is required"
                      ? "pan code is required"
                      : null
                    : null
                }
                errorTrue={
                  (panCard &&
                    panCard.length > 0 &&
                    panCard &&
                    panCard.length <= 9) ||
                  errors.panCard === "panCard is required"
                    ? true
                    : false
                }
                labelText="PAN Number (10-character code)"
                controlClass={
                  (panCard &&
                    panCard.length > 0 &&
                    panCard &&
                    panCard.length <= 9) ||
                  errors.panCard === "panCard is required"
                    ? "outlined-error-helper-text"
                    : "outlined-helperText"
                }
              />
            </div>
          </div>
          {!this.state.progress && this.state.progress === 0 ? null : (
            <AlertDialogProgress
              progress={this.state.progress}
              title="file Uploading..."
            />
          )}
          <div className="col-12 bank-error-message-spacing p-0">
            <SimpleReactLightbox>
              <MultipleImageUploadComponent
                title="Upload Documents*"
                smallTitle="(Upload supporting documents for PAN, GST, FSSAI and a Cancelled Cheque as applicable)"
                onChange={this.kycUploadMultipleFiles}
                stateValue={this.state.kyc_photo && this.state.kyc_photo}
                newUploaded={
                  this.state.restaurant_pictures_new
                    ? this.state.restaurant_pictures_new
                    : []
                }
                combined={this.state.combined}
                onCompleteUploadMultipleCrop={this.onCompleteUploadMultipleCrop}
                removeImage={this.kycDocMultipleRemove}
                cancelFiles={this.cancelFiles}
                accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
              />
            </SimpleReactLightbox>
          </div>
          <div className="f11-400 opacity5 mb-3">
            You may receive a call for KYC and Confirmation
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              buttonType="button"
              onClick={this.backSecondScreenClickChange}
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                (gstNumber === "" && gstNumber.length <= 14) ||
                (fssaiCode === "" && fssaiCode.length <= 13) ||
                (panCard === "" && panCard.length <= 9) ||
                kyc_photo.length === 0
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                (gstNumber === "" && gstNumber.length <= 14) ||
                (fssaiCode === "" && fssaiCode.length <= 13) ||
                (panCard === "" && panCard.length <= 9) ||
                kyc_photo.length === 0
                  ? true
                  : false
              }
              buttonText="Next"
              onClick={this.buttonNextClickChange}
              buttonType={actionButton === false ? "button" : "submit"}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  onClickSkipButton = () => {
    const formData = {};
    formData.vendor_id = this.props.onboarding.vendor_id;
    formData.id = this.props.onboarding._id;
    formData.softOnboarding = true;
    formData.selectHomeScreen = this.state.selectHomeScreen;
    // formData.page_completed_till = 21;
    if (this.props.onboarding) {
      this.props.create_and_update_restaurant(formData, this.onSuccessData);
      this.setState({
        actionButton: false,
      });
    }
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    const { selectHomeScreen } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <div className="col-12 onboarding_process_screen_left-backbutton">
                {selectHomeScreen === 1 ? (
                  <div>
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        backButtonClicked="/businessHours"
                      />
                    </div>
                    <div className="onboarding_process_screen-left-mapinside text-center">
                      <BankAndOtherDetailsHome
                        onClick={this.buttonClickChange}
                      />
                    </div>
                  </div>
                ) : null || selectHomeScreen === 2 ? (
                  <div>
                    <Media query="(min-width: 992px)">
                      <div className="col-12">
                        <BackLogoIconButton
                          displayBackText={true}
                          displayArrow={true}
                          backButtonClicked="/businessHours"
                        />
                      </div>
                    </Media>
                    <Media query="(max-width: 991px)">
                      <MobileTopHeader link={true} onLink={"/businessHours"} />
                    </Media>
                    <div className="onboarding_process_screen-button-map">
                      <div className="restaurant_type_onboarding_main">
                        <div className="row mb-4 align-items-center">
                          <div className="col-10">
                            <div className="f20_700_HelveticaNeue">
                              Business KYC and License Information
                            </div>
                          </div>
                          <div className="col-2">
                            <Button
                              style={{ backgroundColor: "transparent" }}
                              className="btn border-0 p-0 m-0"
                              onClick={() => this.onClickSkipButton()}
                            >
                              <div
                                className="f11-700"
                                style={{ color: "#2196F3" }}
                              >
                                Skip for now
                              </div>
                            </Button>
                          </div>
                        </div>

                        <div className="f18-700 mb-3">KYC and License Info</div>
                        <BankKycDetailsInformation
                          buttonNextClickChangeOne={(formData) =>
                            this.buttonNextClickChange(formData)
                          }
                          actionCall={this.state.actionButton}
                          backSecondScreenClickChange={
                            this.backSecondScreenClickChange
                          }
                        />
                        {/* <Form noValidate onSubmit={this.onHandleSubmit}>
                          {this.renderSecondScreen()}
                        </Form> */}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                selectedProgressBarTwo="active"
                selectedProgressBarThree="active"
                selectedProgressBarFour="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-03.svg")}
              />
            </div>
          </div>
        </div>
        <Modal
          show={this.state.openModal}
          onHide={this.handleCloseSuccess}
          centered
        >
          <Modal.Header className="border-0" closeButton></Modal.Header>
          <Modal.Body className="text-center">
            <Image
              className="w-50 my-4"
              src={require("../../../../assets/images/UserManagement/check-circle.svg")}
            />
            <div
              style={{ color: "#4caf50" }}
              className="f24_700_HelveticaNeue text-center pb-4"
            >
              Success!
            </div>
            <div className="f18-500">
              Thank You for Completing Your Profile.
            </div>
            <div className="f12-400 text-gray pb-5 pt-3 w-75 m-auto">
              We will get in touch with you by email in the next couple of days.
            </div>
            <div className="row">
              <div className="col-md-6 col-12">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={(e) =>
                    this.props.history.push("/subscriptiondescription")
                  }
                >
                  Continue to Subscription
                </Button>
              </div>
              <div className="col-md-6 col-12">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={this.onCombackLater}
                >
                  Come Back Later to Complete
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

BankAndOtherDetails.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  update_vendor_profile,
  logOutUser,
})(withRouter(BankAndOtherDetails));
